import React from 'react';
import styles from './PowerfullSection.module.scss';
import { useNavigate } from 'react-router-dom';
import InstantlyVideo from '../../../assets/landingpage/videos//new.mov';
import MultipleBrandVideo from '../../../assets/landingpage/videos/multiple-brand-video.mov';
import EditorVideo from '../../../assets/landingpage/videos/Specialised AI.mov';
import DashboardAnimation from '../../../assets/landingpage/videos/DashbordAnimation.mp4';

const PowerfullSection = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.powerfullSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          <span>Powerful Features</span> That Power Your Content
        </h2>
        <div className={styles.features}>
          {[
            {
              title: 'Brand Intelligence Hub',
              id: 'brand-intelligence-hub',
              description:
                'Scan your website to instantly extract your brand profile — tone, messaging, positioning, audience, and content strategy. Scan and scrape your social channels to learn what you post, how you engage, what performs, and how your brand shows up across every platform. Your content is analyzed into a Brand DNA fingerprint that powers every AI generation automatically.',
              source: MultipleBrandVideo,
            },
            {
              title: 'Instantly Generate Content Plans',
              id: 'instantly-generate-content-plans',
              description:
                "Vocable maps out channel-specific content ideas, creating a strategic flow of high-impact posts. It's like having a content strategist and copywriter all rolled into one, turning what would take weeks into something that happens in minutes.",
              source: InstantlyVideo,
            },
            {
              title: 'Refine and Improve with Multi-AI Assistance:',
              id: 'refine-with-ai-assistance',
              description:
                'Each post can be customized in the entry editor using our "customize" brief to provide additional instructions. The editor suggests improvements as you review - while accessing AI assistance with multiple models at your fingertips.',
              source: EditorVideo,
            },
            {
              title: 'Access 30+ High-Converting Templates',
              id: 'access-high-converting-templates',
              description:
                'Skip the guesswork with our library of proven templates for every content type. From SEO blog posts and product descriptions to email sequences and ad copy, each template is designed to help you create winning content on-demand.',
              source: DashboardAnimation,
            },
          ].map(({ title, id, description, source }, index) => (
            <div
              key={index}
              id={id}
              className={styles.featureCard}
              onClick={() => console.log('title')}
            >
              <div className={styles.featureCard__content}>
                <h3 className={styles.title}>{title}</h3>
                <p>{description}</p>
                <button
                  className={`${styles.cta} ${styles.cta__desktop}`}
                  onClick={() => navigate('sign-up')}
                >
                  Start Your Free Trial
                </button>
              </div>
              <div className={styles.featureCard__video}>
                <video
                  src={source}
                  className={styles.video}
                  autoPlay
                  loop
                  muted
                />
              </div>
              <button
                className={`${styles.cta} ${styles.cta__mobile}`}
                onClick={() => navigate('sign-up')}
              >
                Start your FREE Trial
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PowerfullSection;
